import { Inject, Injectable } from '@angular/core';
import { I18NEXT_SERVICE, ITranslationService } from 'angular-i18next';
import { routes } from '../../../../utils/routes';

@Injectable({ providedIn: 'root' })
export class RouteTranslateService {
  constructor(@Inject(I18NEXT_SERVICE) private translateService: ITranslationService) {}

  translateRoute(value: string, relative?: boolean): string {
    if (relative) return `${routes[this.translateService.language as 'it']['routes.' + value]}`;
    else
      return `/${this.translateService.language}/${routes[this.translateService.language as 'it']['routes.' + value]}`;
  }
}
